import {
    UPDATE_TABLE_SUCCESS,
    UPDATE_TABLE_REQUEST,
    UPDATE_TABLE_ERROR,
  } from "./types";
  
  import { BASEURL } from "../../constant/config.js";
  import axios from "axios";
  
  export const updateTable = (token, payload) => (dispatch) => {
    dispatch({ type: UPDATE_TABLE_REQUEST });
    return axios({
      method: "PUT",
      url: `${BASEURL}update/tableUpload/1`,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: payload,
    })
      .then((response) => {
        return dispatch({
          type: UPDATE_TABLE_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        return dispatch({
          type: UPDATE_TABLE_ERROR,
          payload: error.response,
        });
      });
  };
  